<template>
  <div class="ticket-windows-manager">
    <!-- Рендеримо всі відкриті вікна -->
    <viewbox
      v-for="window in windows"
      :key="window.id"
      :windowId="window.id"
      :ifPrevopen="false"
      :ifNextopen="false"
      @prevOpen="handlePrevOpen"
      @nextOpen="handleNextOpen"
      @edit="handleEdit"
      @searchTickets="handleSearchTickets"
      @openTicketById="handleOpenTicketById"
    />

    <!-- Панель мінімізованих вікон -->
    <minimized-tickets-bar />
  </div>
</template>

<script>
import { useTicketWindows } from '@/composables/useTicketWindows.js';
import viewbox from '@/views/newtickets/viewNew/index.vue';
import MinimizedTicketsBar from './MinimizedTicketsBar.vue';

export default {
  name: 'TicketWindowsManager',
  components: {
    viewbox,
    MinimizedTicketsBar
  },
  setup() {
    const { windows } = useTicketWindows();

    return {
      windows
    };
  },
  methods: {
    handlePrevOpen(ticketId) {
      // Логіка відкриття попереднього тікету
      // TODO: Додати логіку навігації по тікетам з таблиці
      console.log('Previous ticket:', ticketId);
    },
    handleNextOpen(ticketId) {
      // Логіка відкриття наступного тікету
      // TODO: Додати логіку навігації по тікетам з таблиці
      console.log('Next ticket:', ticketId);
    },
    handleEdit(ticket) {
      // Емітимо подію для відкриття форми редагування
      this.$emit('editTicket', ticket);
    },
    handleSearchTickets(query, callback) {
      // Емітимо подію для пошуку тікетів
      this.$emit('searchTickets', query, callback);
    },
    handleOpenTicketById(ticketId) {
      // Емітимо подію для відкриття тікету за ID
      this.$emit('openTicketById', ticketId);
    }
  }
};
</script>

<style scoped>
.ticket-windows-manager {
  position: relative;
  z-index: 1040;
}
</style>
